export class Complainant {
    get id() {
        return this.complainantState.id;
    }
    get diligenceNumber() {
        return this.complainantState.diligenceNumber;
    }
    get complainantThirId() {
        return this.complainantState.complainantThirId;
    }
    get manifestation() {
        return this.complainantState.manifestation;
    }
    get dateCreated() {
        return this.complainantState.dateCreated;
    }
    get present() {
        return this.complainantState.present;
    }
    get delivery() {
        return this.complainantState.delivery;
    }
    get collegiate() {
        return this.complainantState.collegiate;
    }
    get userId() {
        return this.complainantState.userId;
    }
    get representativeThirdId() {
        return this.complainantState.representativeThirdId;
    }
    get third_name() {
        return this.complainantState.third_name;
    }
    set diligenceNumber(diligenceNumber) {
        this.complainantState.diligenceNumber = diligenceNumber;
    }
    set complainantThirId(complainantThirId) {
        this.complainantState.complainantThirId = complainantThirId;
    }
    set manifestation(manifestation) {
        this.complainantState.manifestation = manifestation;
    }
    set dateCreated(dateCreated) {
        this.complainantState.dateCreated = dateCreated;
    }
    set collegiate(collegiate) {
        this.complainantState.collegiate = collegiate;
    }
    set present(present) {
        this.complainantState.present = present;
    }
    set delivery(delivery) {
        this.complainantState.delivery = delivery;
    }
    set userId(userId) {
        this.complainantState.userId = userId;
    }
    set representativeThirdId(representativeThirdId) {
        this.complainantState.representativeThirdId = representativeThirdId;
    }
    constructor(complainantState) {
        this.complainantState = complainantState;
    }
    getState() {
        return this.complainantState;
    }
}
